import Vue from 'vue'
import moment from 'moment'

Vue.filter('date', function(value, dateOutputFormat = 'M/D/YYYY hh:mma') {
    if (!value) return ''

    const date = moment.parseZone(value)
    return date.format(dateOutputFormat)
})



// WEBPACK FOOTER //
// ./src/lib/filters.js